import { Profile } from "@models/user.model";

export interface Promotions {
    id: string;
    md: number;
    promotions: {
        name: string;
        bild: string;        
        beschreibung: string | null;
        gueltig_von: string | null;
        loyalty: string | null;
        gilt_fuer_artikelnummern: string | null,
        gueltig_bis: string | null,
        erforderliche_punkte: number,
        barcode: string,
        barcode_bild: string,
        text: string | null,
        typ: number,
        brutto_preis: string | null,
        wert_rabatt: string | null,
        prozentualer_rabatt: number,
        wert_fe: string,
        aktiv: string,
        headingactive: string,
        aktivierbar_von: string | null,
        aktivierbar_bis: string | null,
        anzahl_tage_gueltigkeit: string | null,
        marken: string | null,
        bild_sharelink: string | null,
        formatierter_coupontext: string | null,
        coupon_headline: string | null,
        weitere_infos_rueckseite: string | null,
        text_coupon_vorderseite: string | null,
    };
}

export interface CustomerPromotionActivation {
    id: string;
    md: number;
    kundenpromotions: {
        promotion_id: number;
        kunde: {
            id: string;
        };
        redeemed: string | null;
        kundenbetreuung: string | null;
        ja_nein: string | null;
        text: string | null;
        valid: string;
        active: boolean | null;
        required_points: string;
        list_points: string | null;
        latest_validation: string | null;
        activated: string | null;
        status: PromotionStatus;
    }
}

export interface PromotionsState {
    promotions: Promotions[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

export interface PromotionActivationResponseItem {
    id: number;
    sequence: number;
    createdAt: string;
    createdBy: string;
    modifiedAt: string;
    modifiedBy: string;
    fields: {
        activated: string;
        active: boolean;
        status:PromotionStatus;
    };
}

export type PromotionActivationResponse = PromotionActivationResponseItem[];

export interface CustomerPromotionsState {
    customerPromotions: CustomerPromotionActivation[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

export enum PromotionStatus {
    readyForActivation = 1,
    activated = 2,
    redeemed = 3,
    expired = 4
}
    
export interface CouponProps {
    coupon: Promotions['promotions'];
    isReadyForActivation?: boolean;
    isActivated?: boolean;
    isRedeemed?: boolean;
    isExpired?: boolean;
    index?: number;
    promotionId?: string;
    status?: PromotionStatus;
    latest_validation?: string;
    onStatusUpdate?: (promotionId: string, newStatus: PromotionStatus, active: boolean) => void;
}

/**
 * Props interface for the CouponBackSide component
 */
export interface CouponBackSideProps {
  /** Function to toggle the flipped state of the coupon card */
  setIsFlipped: (isFlipped: boolean) => void;
  /** Promotion data to display */
  coupon: Promotions['promotions'];
  /** User profile data, optional */
  profile?: Profile;
  /** Function to handle coupon activation */
  handleActivatePromotion: () => void;
  /** Flag indicating if activation is in progress */
  isActivating?: boolean;
  /** Flag indicating if a coupon is activated */
  isActivated?: boolean;
  /** Flag indicating if a coupon is redeemed */
  isRedeemed?: boolean;
  /** Flag indicating if a coupon is expired */
  isExpired?: boolean;
  /** Promotion ID */
  promotionId?: string;
  /** Latest validation date */
  latest_validation?: string;
}